<!--
 * @Author: lhb
 * @Date: 2019-12-16 15:44:04
 * @LastEditTime : 2019-12-24 15:03:58
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \enterprise_management\src\components\ManagementLayout.vue
 -->
<template lang="pug">
  .columns.is-horizontal(:class="{'height-35': (is_show_open_store == 1 || is_show_tip == 1)}")
    major-nav
    keep-alive
      router-view.column.manage-layout(v-if="$route.meta.keepAlive")
    router-view.column.manage-layout(v-if="!$route.meta.keepAlive")
</template>

<script>
import MajorNav from './generics/MajorNav'
import { root } from '@/plugins/Fetch'
import { mapGetters } from 'vuex'

export default {
  name: 'ManagementLayout',
  components: {
    MajorNav,
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      fetchLoading: 'fetchLoading',
    }),
  },
  data () {
    return {
      is_show_open_store: 0, // 门店开通信息完善提醒展开，下面的高度需要修改
      is_show_tip: 0, // 门店活动提醒，下面的高度需要修改
      socket_num: 0,
      root,
    }
  },
  watch: {
    '$route.meta.module': function (newVal, oldVal) {
      // 监听路由，间接获取到门店开通信息完善提醒是否展开，然后动态修改高度
      this.is_show_open_store = sessionStorage.getItem('is_show_open_store')
      this.is_show_tip = sessionStorage.getItem('is_show_tip')
    },
  },
  mounted () {
    this.is_show_open_store = sessionStorage.getItem('is_show_open_store')
    this.is_show_tip = sessionStorage.getItem('is_show_tip')
    setTimeout(() => this.initWebSocket(), 1000)
  },
  methods: {
    // 初始化weosocket
    initWebSocket () {
      const wsuri = this._setWsUrl()
      try {
        this.websock = new WebSocket(wsuri)
      } catch (e) {
        throw e
      }
      this.websock.onopen = this.websocketonopen
      this.websock.onerror = this.websocketonerror
      this.websock.onclose = this.websocketclose
    },
    // 连接建立之后挂载到vuex中
    websocketonopen () {
      this.socket_num = 0
      this.$store.dispatch('setWebSocket', this.websock)
    },
    // 连接建立失败重连
    websocketonerror () {
      if (this.socket_num >= 5) {
        return
      }
      this.socket_num += 1
      this.initWebSocket()
    },
    // 关闭
    websocketclose (e) {
      if (this.socket_num >= 5) {
        return
      }
      this.socket_num += 1
      this.websocketonerror()
    },
    _setWsUrl () {
      let httpHead = this.root.split(':')[1].split('/')[2]
      if (root.split(':')[0] === 'http') {
        return `ws://${httpHead}/swoole_message_server`
      }
      if (root.split(':')[0] === 'https') {
        return `wss://${httpHead}/swoole_message_server`
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
  .manage-layout
    overflow hidden
    background #f0f1f2
  .height-35
    height calc(100vh - 35px)
</style>



// WEBPACK FOOTER //
// src/components/ManagementLayout.vue